import { AddressSearchRequest, ParcelRequest, ShippingRatesRequest } from '../api-client/models';
import {shippingAPi} from '../api/index';
import axiosInstance from '../api/axios';

export interface CalculateTotalPayload {
  items?: { product_item_id: number; quantity: number }[];
  shopping_car?: number;
  address: { state: string; [key: string]: unknown };
  shipping_cost: number | string;
  discount_amount?: number | string;
  currency?: string;
}

export interface CalculateTotalResponse {
  subtotal: string;
  tax_rate: number;
  tax_amount: string;
  shipping_cost: string;
  discount: string;
  total: string;
  amount_cents: number;
  currency: string;
}


export const validateAddress = async (address: AddressSearchRequest) => {
    try {
        const response = await shippingAPi.shippingAddressSearchCreate({ addressSearchRequest: address });
        return response;
    } catch (error) {
        console.error('Error validating address:', error);
        throw error;
    }
};

export const parcelsCreate = async (parcels: ParcelRequest)=>{
    try{
        const response = await shippingAPi.shippingParcelsCreate({
            parcelRequest: parcels
        })
        return response;
    } catch(error){
        console.error('Error creating parcel: ', error);
        throw error;
    }
}

export const shippingCreate = async (shipping: ShippingRatesRequest, )=>{
    try{
        const response = await shippingAPi.shippingShippingCreate({
            shippingRatesRequest: shipping
        })
        return response;
    } catch(error){
        console.error('Error creating parcel: ', error);
        throw error;
    }
}

export const calculateStripeTotal = async (payload: CalculateTotalPayload): Promise<CalculateTotalResponse> => {
  const response = await axiosInstance.post('/api/payments-stripe/calculate-total/', payload);
  return response.data;
};


